export const NEW_SHIPPING_TOKEN_REQUEST = "NEW_AUTHENTICATION_TOKEN_REQUEST"
export const NEW_SHIPPING_TOKEN_SUCCESS = "NEW_AUTHENTICATION_TOKEN_SUCCESS"
export const NEW_SHIPPING_TOKEN_FAIL = "NEW_AUTHENTICATION_TOKEN_FAIL"